import React, { useState } from 'react'
import moment from 'moment-timezone'
import { useApolloClient } from '@apollo/client'
import { Col, Avatar, Row, Upload } from 'antd'
import { FileImageOutlined, LoadingOutlined } from '@ant-design/icons'
import { useSession } from '@slerp/accounts'
import { UploadModifierImage } from '../Actions'
import env from '../../../../env'

interface ModifierImagesProps {
  modifierId: string
}

const ModifierImages = ({ modifierId }: ModifierImagesProps) => {
  const { merchant } = useSession()
  const client = useApolloClient()
  const imageUrl = `https://${merchant.slug}.${
    env.ASSET_HOST
  }/assets/modifier/${modifierId}?size=original&${moment().unix()}`
  const [imageUploadLoading, setImageUploadLoading] = useState(false)

  const beforeImageUpload = (file: File) => {
    setImageUploadLoading(true)
    return true // this always expects a boolean return value
  }
  return (
    <>
      <Row justify='center'>
        <Col>
          <Upload
            name='avatar'
            accept='.png, .jpg, .jpeg'
            listType='picture-card'
            className='avatar-uploader'
            showUploadList={false}
            customRequest={({ file, onSuccess, onError }) =>
              UploadModifierImage({
                modifierId,
                image: file
              })
                .then((res) => {
                  setImageUploadLoading(false)
                  client.resetStore()
                  onSuccess(res, file)
                })
                .catch((error: Error) => {
                  setImageUploadLoading(false)
                  onError(error)
                })
            }
            beforeUpload={beforeImageUpload}
          >
            {!imageUploadLoading ? (
              <Avatar size={400} shape='square' src={imageUrl} />
            ) : imageUploadLoading ? (
              <LoadingOutlined />
            ) : (
              <FileImageOutlined />
            )}
          </Upload>
        </Col>
      </Row>
    </>
  )
}

export default ModifierImages
